import React from "react";

// Style \\
import "../../assets/styles/card/aboutCard.scss";

// Images \\
import avatarSofa from "../../assets/images/making.jpg";

const AboutUsCard = () => {
  return (
    <div className="hospitalName_items">
      <div className="hospitalName_items_image w-[500px]">
        <img src={avatarSofa} className="w-full" alt="" />
      </div>

      <div className="hospitalName_items_text">
        <div className="title">
          <p>
            Welcome to preparation <br /> process of furniture
          </p>
          <h3>
            Best choice for Your <br /> Good Interior
          </h3>
        </div>

        <div className="medical_sections">
          <div className="oneCol">
            <div className="part">
              <div className="round"></div>
              <p>Lorem, ipsum dolor.</p>
            </div>
            <div className="part">
              <div className="round"></div>
              <p>Lorem, ipsum dolor.</p>
            </div>
            <div className="part">
              <div className="round"></div>
              <p>Lorem, ipsum dolor.</p>
            </div>
          </div>

          <div className="oneCol">
            <div className="part">
              <div className="round"></div>
              <p>Lorem, ipsum dolor.</p>
            </div>
            <div className="part">
              <div className="round"></div>
              <p>Lorem, ipsum dolor.</p>
            </div>
            <div className="part">
              <div className="round"></div>
              <p>Lorem, ipsum dolor.</p>
            </div>
          </div>
        </div>

        <div className="text">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
            placerat scelerisque tortor ornare ornare. Quisque placerat
            scelerisque tortor ornare ornare Convallis felis vitae tortor augue.
            Velit nascetur proin massa in. Consequat faucibus porttitor enim et.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
            placerat scelerisque. Convallis felis vitae tortor augue. Velit
            nascetur proin massa in.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUsCard;
